
import {Router} from "@angular/router";
import {Component, ElementRef} from "@angular/core";
/**
 * Created by nijin on 16/3/17.
 */
@Component({
  selector:'nuc-button-drop',
  host : {
    '(document:click)': 'onDocumentClick($event)'
  },
  template: `
<div class="btn-group " role="group" aria-label="...">
			  	<button type="button" class="btn btn-default btn-primary" (click)="navigate()" id="add-new">
			  		<span class="icon icon-plus-white"></span>
			  		<span>Add New</span>
			  	</button>
   <div class="btn-group " role="group" [ngClass]="{'open': isOpen}">
					<button type="button" class="btn btn-default btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" id="add-new-options" aria-expanded="false" (click)="isOpen = !isOpen">
						<span class="icon icon-arrow-white-small"></span>
					</button>
					<ul class="dropdown-menu" id="menu-dropdown">
					  	<li><a [routerLink]="['/things/device/new']" id="new-thing">New Thing</a></li>
					  	<li><a [routerLink]="['/things/app/new']" id="new-app">New Mobile App</a></li>
					</ul>
				</div>
				</div>
   `
})

export class DropDownButton {
   isOpen = false;
  constructor(private el: ElementRef, private router: Router) {

  }
  onDocumentClick(event) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }

  }
  navigate() {
    this.router.navigate(['/things/device/new']).then();
  }

}




// WEBPACK FOOTER //
// ./src/app/things/things-list/dropdown-button.directive.ts